/**
 *聊天框数据状态存储
 */

const getDefaultState = () => {
  return {
    // 当前是否登录
    isWebIMLogin: undefined,
    // 当前的聊天框是否打开, 用来判断是否增加总洽谈数
    isChatModelShow: false,
    // 右上角消息中心是否显示
    isMsgCenterShow: false,

    // 当前登录角色信息 等同于userinfo
    currentUser: {
      id: 1,
      avatar: '',
      nickname: '',
    },

    // 游客的角色信息, 同一身份在一台电脑上刷新后也保存起来
    visitorUser: {
      huanxinId: '',
      ip: '',
      ipLocation: '',
    },

    // 如果id是-1,说明不是游客
    IMLoginInfo: {
      id: -1,
    },

    // 未读站内信数量
    sysMessageUnReadNum: 0,
    // 洽谈的全部未读数
    talkUnReadNum: 0,
    // 消息中心未读数(未读总数)
    allUnReadNum: 0,
    // admin噪音信息, 要隐藏
    adminUnReadNum: 0,

    // 被洽谈角色信息
    currentSession: {
      id: 0,
      nickname: '群聊',
      avatar: '',
      chat: null,
    },

    // 当前被洽谈者的相关信息
    otherUserInfo: {
      roleId: 1,
    },

    // 环信官方洽谈列表
    sessionList: [],

    connection: null,

    notice: {
      show: false,
      type: '',
      msg: '',
    },

    // 消息列表
    msgList: {
      contact: {},
      group: {},
      chatroom: {},
    },
    // 右上角消息列表
    msgCenterList: [],
    // notifications消息列表
    notificationsMsgList: [],
    // 弹出框的消息列表
    modalMsgList: [],

    // 已联系人列表
    contantList: [],

    /**
     * 直播聊天室状态
     * corpseNum: 累计观看人数
     * */

    chatRoomInfo: { status: 'normal', cont: '', corpseNum: '' },
    // 直播间真实人数
    joinNum: 0,

    /**
     * 音视频
     */
    // 是否显示音视频的框
    emediaModalVisible: false,
    /**
     * 音视频的头像和名称
     * type: VIDEO VOICE
     * */

    webrtcBaseInfo: {
      avatar: 'https://oss-resource668.yzdli.com/website/image/default/default-avatar.png',
      userName: '',
      type: '',
    },

    // 右键菜单
    rightMenu: {
      status: 'none',
      top: '0px',
      left: '0px',
      msgInfo: {
        text: '',
        to: '',
      },
      // 原始的信息
      originalInfo: {},
    },
  }
}

export const state = getDefaultState

export const actions = {
  // 新增聊天室的历史消息
  addChatRoomHistoryMsg: ({ commit, dispatch }, info) => {
    const historyMessages = info.historyMessages

    commit('ADD_CHATROOM_HISTORYMESSAGE', historyMessages)
  },
  // 添加洽谈消息
  addMessage: ({ commit }, message) => {
    commit('ADD_MESSAGE', message)
  },
  // 监听中的更新信息
  updateMsgList: ({ commit }, message) => {
    commit('UPDATE_MESSAGE_LIST', message)
  },
  // 修改真实在线人数
  updateJoinNum: ({ commit }, message) => {
    commit('UPDATE_JOIN_NUM', message)
  },
  updateMessageFormList({ commit }, message) {
    commit('UPDATE_MESSAGE_FORM_LIST', message)
  },
}

// 用全部大写命名 mutation 是一个惯例,方便将它和 actions 区分开
export const mutations = {
  // 重置所有值
  RESET_ALL(state) {
    console.log('重置store/chat')
    const initState = getDefaultState()
    Object.keys(initState).forEach((key) => {
      state[key] = initState[key]
    })
    state.isWebIMLogin = undefined
  },
  // 重置 currentSession
  RESET_CURRENT_SESSION: (state) => {
    state.currentSession = {
      id: 0,
      nickname: '群聊',
      avatar: '',
      chat: null,
    }
  },
  UPDATE_MESSAGE_FORM_LIST: (state, message) => {
    const newContact = { ...state.msgList.contact }
    const sessionId = state.currentSession.id
    console.log('更新消息列表中的一条消息', message, sessionId)

    // 判断消息是否属于当前会话（自己发的消息 to 是对方，对方发的消息 from 是对方）
    const isCurrentSession = message.from === sessionId || message.to === sessionId

    if (isCurrentSession && newContact[sessionId] && newContact[sessionId].length > 0) {
      const msgIndex = newContact[sessionId].findIndex((data) => data.id === message.id)
      if (msgIndex !== -1) {
        // 使用 Vue.set 或直接替换数组来确保响应式更新
        newContact[sessionId] = [
          ...newContact[sessionId].slice(0, msgIndex),
          { ...message },
          ...newContact[sessionId].slice(msgIndex + 1),
        ]
        state.msgList = { ...state.msgList, contact: newContact }
        console.log('消息更新成功', msgIndex, newContact[sessionId][msgIndex])
      }
    }
  },
  /**
   * 修改当前聊天的人信息
   * 发送已读消息, 和对方说还已经发送
   * */
  SWITCH_OTHER_INFO: (state, otherUserInfo) => {
    const userInfo = otherUserInfo
    if (!userInfo.huanxinId) {
      userInfo.huanxinId = otherUserInfo.memunicode || otherUserInfo.memUnicode
    }
    state.otherUserInfo = userInfo
  },
  /**
   * @description: 初始化洽自己的信息
   * @param {*}
   * @return {*}
   */
  INIT_CURRENT_USER: (state, currentUser) => {
    console.log('INIT_CURRENT_USER', currentUser)
    currentUser.id = currentUser.huanxinId
    state.currentUser = currentUser
  },
  INIT_IMLOGIN_INFO: (state, IMLoginInfo) => {
    console.log('INIT_IMLOGIN_INFO', IMLoginInfo)
    state.IMLoginInfo = IMLoginInfo
  },

  /**
   * @description: 初始化游客信息
   * @param {*}
   * @return {*}
   */
  INIT_VISITOR_USER: (state, visitorUser) => {
    console.log('INIT_VISITOR_USER', visitorUser)
    state.visitorUser = visitorUser
  },
  /**
   * @description: 初始化对方的消息
   * @param {*}
   * @return {*}
   */
  INIT_SESSION_USER: (state, currentSession) => {
    console.log('INIT_SESSION_USER', currentSession)
    currentSession.id = currentSession.huanxinId
    state.currentSession = currentSession
  },

  // 初始化音视频头像名称
  INIT_WEBRTC_BASEINFO: (state, info) => {
    console.log('INIT_WEBRTC_BASEINFO', info)
    state.webrtcBaseInfo = JSON.parse(JSON.stringify(info))
  },

  // 新增洽谈的历史消息
  ADD_HISTORY_MESSAGE: (state, historyMessages) => {
    console.log('ADD_HISTORY_MESSAGE', historyMessages)
    // 如果消息列表为空
    if (!state.msgList) {
      state.msgList = {
        contact: {},
        group: {},
        chatroom: {},
      }
    }

    // 全部的数据
    let allDataList =
      !state.currentSession.id || !state?.msgList?.contact[state.currentSession.id]
        ? []
        : state.msgList.contact[state.currentSession.id].slice(0)

    // 如果历史消息为空
    if (!historyMessages || !historyMessages.length) {
      return
    }

    // 当前循环的数据
    const dataList = []
    for (const item of historyMessages) {
      // 如果是单聊
      if (item.type !== 'chat') {
        break
      }

      const msg = {
        ...item,
        user: {
          id: item.from,
          avatar: '',
          nickname: '',
        },
      }

      // 如果是当前登录用户发送的
      if (item.from === state.currentUser.id) {
        msg.user.avatar = item.ext && item.ext.sendUrl ? item.ext.sendUrl : state.currentUser.avatar
        msg.user.nickname =
          item.ext && item.ext.sendName ? item.ext.sendName : state.currentUser.nickname || state.currentUser.username
        msg.status = ''
      } else if (item.from === state.currentSession.id) {
        msg.user.avatar = item.ext && item.ext.sendUrl ? item.ext.sendUrl : state.currentSession.pic
        msg.user.nickname = item.ext && item.ext.sendName ? item.ext.sendName : state.currentSession.contact
        msg.status = 'read'
      }

      dataList.push(msg)
    }

    allDataList = [...dataList, ...allDataList]

    // 数组对象去重（使用 Map 保持顺序并提升性能）
    const uniqueMap = new Map()
    allDataList.forEach((item) => {
      if (!uniqueMap.has(item.id)) {
        uniqueMap.set(item.id, item)
      }
    })
    allDataList = Array.from(uniqueMap.values())

    allDataList = allDataList.sort((a, b) => {
      return a.time - b.time
    })

    const contact = JSON.parse(JSON.stringify(state.msgList.contact))

    if (contact[state.currentSession.id] === undefined) {
      contact[state.currentSession.id] = []
    }

    contact[state.currentSession.id] = allDataList
    state.msgList.contact = contact
  },

  // 新增聊天室历史消息
  ADD_CHATROOM_HISTORYMESSAGE: (state, historyMessages) => {
    // console.log('新增聊天室历史消息', historyMessages)
    if (!historyMessages || !historyMessages.length) {
      return
    }
    if (!state.msgList) {
      state.msgList = {
        contact: {},
        group: {},
        chatroom: {},
      }
    }

    const chatroom = JSON.parse(JSON.stringify(state.msgList.chatroom))

    if (chatroom[historyMessages[0].to] === undefined) {
      chatroom[historyMessages[0].to] = []
    }

    chatroom[historyMessages[0].to] = historyMessages
    state.msgList.chatroom = chatroom
  },

  /**
   * 洽谈新增信息
   * 当a和b洽谈时, 可能有c发消息过来, 所以要以message里面的currentSession为准
   * currentSession = {id,contact,pic}
   * */

  ADD_MESSAGE: (state, message) => {
    console.log('添加洽谈消息', message)
    let currentSession = message.currentSession || state.currentSession
    if (message.currentSession) {
      currentSession = message.currentSession
      delete message.currentSession
    }

    if (!state.msgList) {
      state.msgList = {
        contact: {},
        group: {},
        chatroom: {},
      }
    }
    const msg = {
      ...message,
      user: {
        id: message.from,
        avatar: '',
        nickname: '',
      },
    }

    // 如果是当前登录用户发送的
    if (message.from === state.currentUser.id) {
      msg.user.avatar = message.ext && message.ext.sendUrl ? message.ext.sendUrl : state.currentUser.avatar
      msg.user.nickname =
        message.ext && message.ext.sendName
          ? message.ext.sendName
          : state.currentUser.nickname || state.currentUser.username

      // 右上角消息中心列表更新
      if (state.msgCenterList.length > 0) {
        for (const i of state.msgCenterList) {
          if (i.talkMessageLog.huanxinId === message.to) {
            i.talkMessageLog.lastMessage = message.data
            break
          }
        }
      }

      // 洽谈页面的
      if (state.notificationsMsgList.length > 0) {
        for (const i of state.notificationsMsgList) {
          if (i.talkMessageLog.huanxinId === message.to) {
            i.talkMessageLog.lastMessage = message.data
            break
          }
        }
      }

      if (state.modalMsgList.length > 0) {
        for (const i of state.modalMsgList) {
          if (i.talkMessageLog.huanxinId === message.to) {
            i.talkMessageLog.lastMessage = message.data
            break
          }
        }
      }
    } else if (message.from === currentSession.id) {
      // 如果是对方发过来的消息
      msg.user.avatar = message.ext && message.ext.sendUrl ? message.ext.sendUrl : currentSession.pic
      msg.user.nickname = message.ext && message.ext.sendName ? message.ext.sendName : currentSession.contact
    }

    const contact = JSON.parse(JSON.stringify(state.msgList.contact))

    if (contact[currentSession.id] === undefined) {
      contact[currentSession.id] = []
    }

    contact[currentSession.id].push(msg)

    state.msgList.contact = contact
  },
  /**
   * 更新洽谈列表
   * 更新总的存储, 消息中心列表和右上角的的消息通知
   * */

  UPDATE_MESSAGE_LIST: (state, payload) => {
    const { chatType, chatId, msg, type, mid } = payload
    // console.log(
    //   'UPDATE_MESSAGE_LIST 更新洽谈列表',
    //   payload,
    //   chatType,
    //   chatId,
    //   msg,
    //   type
    // )

    // 看是否有msgList, 没有就新建一个
    if (!state.msgList) {
      state.msgList = {
        contact: {},
        group: {},
        chatroom: {},
      }
    }

    if (!state.msgList[chatType]) {
      state.msgList[chatType] = []
    }

    // status 以后用来判断是否已读

    // 如果是普通聊天
    if (chatType === 'contact') {
      // 如果是新联系人
      if (!state.msgList[chatType][chatId]) {
        state.msgList[chatType][chatId] = [
          {
            msg,
            type: type || '',
            mid,
            status,
            ...payload,
          },
        ]
      } else {
        state.msgList[chatType][chatId].push({
          msg,
          type: type || '',
          mid,
          status,
          ...payload,
        })

        // 按时间排序
        state.msgList[chatType][chatId] = state.msgList[chatType][chatId].sort((a, b) => {
          return a.time - b.time
        })
      }

      let lastMessage = payload.msg

      switch (payload.contentsType) {
        case 'IMAGE':
          lastMessage = '[图片]'
          break
        case 'FILE':
          lastMessage = '[附件]'
          break
        case 'VIDEO':
          lastMessage = '[视频]'
          break
      }

      // 右上角消息中心列表更新
      if (state.msgCenterList.length > 0) {
        for (const i of state.msgCenterList) {
          if (String(i.talkMessageLog.toHuanxinId) === String(payload.from)) {
            i.talkMessageLog.lastMessage = payload.msg || lastMessage
            i.talkMessageLog.unReadNum = i.talkMessageLog.unReadNum ? i.talkMessageLog.unReadNum + 1 : 1
            break
          }
        }
      }

      // 洽谈页面的
      if (state.notificationsMsgList.length > 0) {
        for (const i of state.notificationsMsgList) {
          if (String(i.talkMessageLog.toHuanxinId) === String(payload.from)) {
            i.talkMessageLog.lastMessage = payload.msg || lastMessage
            i.talkMessageLog.unReadNum += 1
            break
          }
        }
      }

      // 弹出的modal框更新
      // console.log(
      //   '弹出的modal框更新',
      //   state.modalMsgList,
      //   state.modalMsgList.talkMessageLog,
      //   payload.from
      // )
      if (state.modalMsgList.length > 0) {
        for (const i of state.modalMsgList) {
          if (String(i.talkMessageLog.toHuanxinId) === String(payload.from)) {
            i.talkMessageLog.lastMessage = payload.msg || lastMessage

            if (payload.from !== state.currentSession.huanxinId) {
              i.talkMessageLog.unReadNum += 1
            }
            break
          }
        }
      }
    } else if (chatType === 'chatroom') {
      // 如果是聊天室

      // 如果是加入或退出聊天室
      if (!chatId && payload.gid) {
        // 如果初始值为空
        if (!state.msgList[chatType][payload.gid]) {
          console.log('加入聊天室', payload.em_join)
          state.msgList[chatType][payload.gid] = [
            {
              type: payload.type,
              ext: {
                sendName: payload.from,
                em_join: payload.em_join,
                em_leave: payload.em_leave,
              },
            },
          ]
        } else {
          state.msgList[chatType][payload.gid].push({
            type: payload.type,
            ext: {
              sendName: payload.from,
              em_join: payload.em_join,
              em_leave: payload.em_leave,
            },
          })
        }
      } else if (!state.msgList[chatType][chatId]) {
        // 接收聊天室
        state.msgList[chatType][chatId] = [
          {
            msg,
            type: type || '',
            mid,
            status,
            ...payload,
          },
        ]
      } else {
        state.msgList[chatType][chatId].push({
          msg,
          type: type || '',
          mid,
          status,
          ...payload,
        })
      }
      console.log('chatroom', state.msgList)
    }
    state.msgList = { ...state.msgList }
  },
  // 更新页面右上角消息中心
  UPDATE_MSGCENTER_LIST: (state, list) => {
    state.msgCenterList = list
  },
  // 更新消息中心页面列表
  UPDATE_NOTIFICATIONS_MSG_LIST: (state, list) => {
    state.notificationsMsgList = list
  },
  UPDATE_MODAL_MSG_LIST: (state, list) => {
    console.log('UPDATE_MODAL_MSG_LIST')
    state.modalMsgList = list
  },

  // 更新聊天室信息
  UPDATE_CHATROOM_INFO: (state, info) => {
    console.log('info', info)
    state.chatRoomInfo = info
  },
  // 更新全部的未读消息数
  UPDATE_UNREAD_MSG_NUM: (state, msgList) => {
    msgList.map((item) => {
      let num = 0
      if (item.num > 0) {
        num = item.num
      }
      // console.log('UPDATE_UNREAD_MSG_NUM', msgList, num)

      state[item.name] = num || 0
    })
  },
  // 修改当前洽谈总未读数
  UPDATE_CHAT_UNREAD_NUM: (state, num) => {
    const unReadNum = num < 0 ? 0 : num
    console.log('UPDATE_CHAT_UNREAD_NUM', unReadNum)
    state.talkUnReadNum = unReadNum
  },
  // 修改当前admin未读数
  UPDATE_CHAT_ADMIN_UNREAD_NUM: (state, num) => {
    const unReadNum = num < 0 ? 0 : num
    console.log('UPDATE_CHAT_ADMIN_UNREAD_NUM', unReadNum)
    state.adminUnReadNum = unReadNum
  },
  // 更新系统消息未读数
  UPDATE_SYSTEM_MSG_UNREAD: (state, num) => {
    state && (state.sysMessageUnReadNum = num)
  },
  // 更新环信官方会话列表
  UPDATE_CHAT_SESSION_LIST: (state, info) => {
    state.sessionList = info
  },
  // 切换聊天框显示隐藏
  switchChatModelShow: (state, status) => {
    state.isChatModelShow = status
  },
  // 切换音视频聊天框信息
  switchEmediaModalVisible: (state, status) => {
    state.emediaModalVisible = status
  },
  switchMsgCenterShow: (state, status) => {
    state.isMsgCenterShow = status
  },

  // 切换环信连接状态
  switchWebIMStatus(state, status) {
    // console.log('switchWebIMStatus', state, status)
    state && (state.isWebIMLogin = status)
  },
  /**
   * 更新消息状态
   * 默认是已读未读
   * @param {Object} msg&status 消息和状态
   * @param state
   * */
  // 已读未读模块用
  updateMessageStatus(state, { id, serverMsgId, message, status = 'read' }) {
    // console.log('updateMessageStatus已读未读模块用')
    if (!state.msgList.contact || !state.currentSession.id) {
      return
    }
    const contactItem = state.msgList.contact[state.currentSession.id]
    if (contactItem && contactItem.length > 0) {
      for (let i = contactItem.length - 1; i >= 0; i--) {
        if (id) {
          // 如果只更改状态
          if (String(contactItem[i].id) === String(id)) {
            // 如果有服务器信息id, 将本地信息id换成服务器id
            if (serverMsgId) {
              contactItem[i].id = serverMsgId
            }

            contactItem[i] = {
              ...contactItem[i],
              status,
            }
            break
          }
        } else if (message && message.mid) {
          // 如果是已读未读
          if (String(contactItem[i].id) === String(message.mid)) {
            contactItem[i] = {
              ...contactItem[i],
              status,
            }
            break
          }
        }
      }

      state.msgList.contact[state.currentSession.id] = contactItem
      // console.log('contactItem', contactItem)
      state.msgList = { ...state.msgList }
    }
  },
  UPDATE_JOIN_NUM(state, status) {
    state.joinNum = status
  },
  // 增加已联系的人
  addContantList(state, status) {
    console.log('增加已联系的人', status)
    if (!state.contantList) {
      state.contantList = []
    }
    state.contantList.push(status)
  },
  // 更新右键菜单数据
  updateRightMenuStatus(state, menuObj) {
    state.rightMenu = {
      ...menuObj,
    }
  },
}
export const getters = {
  currentUser: ({ currentUser }) => currentUser,
  visitorUser: ({ visitorUser }) => visitorUser,

  IMLoginInfo: ({ IMLoginInfo }) => IMLoginInfo,
  isChatModelShow: ({ isChatModelShow }) => isChatModelShow,
  isMsgCenterShow: ({ isMsgCenterShow }) => isMsgCenterShow,

  talkUnReadNum: ({ talkUnReadNum }) => {
    // console.log('talkUnReadNum', talkUnReadNum, adminUnReadNum)
    return talkUnReadNum || 0
    // return talkUnReadNum
  },
  allUnReadNum: ({ talkUnReadNum, sysMessageUnReadNum }) => {
    return (talkUnReadNum || 0) + (sysMessageUnReadNum || 0)
  },
  currentSession: ({ currentSession }) => currentSession,

  msgList: ({ msgList }) => msgList,
  msgCenterList: ({ msgCenterList }) => msgCenterList,
  notificationsMsgList: ({ notificationsMsgList }) => notificationsMsgList,
  modalMsgList: ({ modalMsgList }) => modalMsgList,

  chatRoomInfo: ({ chatRoomInfo }) => chatRoomInfo,
  // 环信是否登录
  isWebIMLogin: ({ isWebIMLogin }) => isWebIMLogin,
  // 被洽谈者
  otherUserInfo: ({ otherUserInfo }) => otherUserInfo,

  conn: ({ connection }) => {
    if (connection !== null) {
      return connection
    }
  },

  notice: ({ notice }) => notice,
  contantList: ({ contantList }) => contantList,
}
